/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Inventory_No_HoldingsInputs */



/**
* | output |
* | --- |
* | "No recorded holdings yet — record a movement to start tracking stock." |
*
* @param {Promo_Inventory_No_HoldingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_inventory_no_holdings = /** @type {((inputs?: Promo_Inventory_No_HoldingsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Inventory_No_HoldingsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun stock enregistré pour le moment — enregistrez un mouvement pour commencer à suivre le stock.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no hay stock registrado — registre un movimiento para empezar a hacer seguimiento del stock.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ainda não há estoque registrado — registre uma movimentação para começar a acompanhar o estoque.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuno stock registrato ancora — registra un movimento per iniziare a monitorare lo stock.")
	return /** @type {LocalizedString} */ ("No recorded holdings yet — record a movement to start tracking stock.")
});